import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight, Star, Facebook } from 'lucide-react';

interface Review {
  title: string;
  content: string;
  author?: string;
  date?: string;
  rating: number;
}

interface ReviewCarouselProps {
  type: 'restaurant' | 'snooker';
}

const restaurantReviews: Review[] = [
  {
    title: "Outstanding August 2025",
    content: "The experience I would like to share is me and the family attended here at the Creamery for dinner and what an outstanding service, the staff were all very pleasant, felt welcomed and the service that was provided was really lovely, the food was also on another level also. I have attended several restraunts around Falkirk and surrounding areas in my time. And I report that the food gets a 10 outa 10, was extremely hot and fresh here at the Creamery, the indoor decor was absolute stunning also.",
    date: "August 2025",
    rating: 5
  },
  {
    title: "Outstanding August 2025",
    content: "Went for lunch with the family and it was lovely from start to finishing, great service from staff, went for a couple of games of pool to finish of and yes we will definitely be back so big thank you to creamer staff",
    date: "October 2024",
    rating: 5
  },
  {
    title: "Quick Stop, Great Surprise",
    content: "Thanks, Team, for letting us enjoy some last minute great food. Pea & Ham soup, breaded mushrooms, egg wrap, Cajun Chicken Pasta, and 2 x StickyDate pudding. Best pasta I've had in AGES, hands down. Two very full bellies on the road now.",
    rating: 5
  },
  {
    title: "Awesome food not to be missed",
    content: "These have to be the best ever garlic mushrooms absolutely awesome and steak pie to die for apple crumble and custard was great too. My granddaughter loved everything she ate as we will definitely be coming back soon 👌",
    rating: 5
  },
  {
    title: "Just the best",
    content: "Whenever I return to my hometown I always make a point of dining here the meals are fantastic and great value would highly recommend this restaurant",
    rating: 5
  },
  {
    title: "Falkirks best hidden gem",
    content: "Have frequented the creamery for many many years, firstly because of the food and secondly because it's local to me. The creamery is such a little hidden gem. From the outside it looks like your average pool hall but when you step in to the restaurant you would never know there are many people playing snooker and pool in the next rooms. The restaurant is beautifully decorated, enough space between tables and very well set up with friendly and knowledgable staff.",
    date: "February 2024",
    rating: 5
  },
  {
    title: "Cracking meals and very filling too!",
    content: "Visited over a month ago and decided it was so good why not try it again? Both glad we did as the 2 courses we had were smashing and tasted great. The Mrs ordered battered mushrooms with garnish and I chose chicken broth...both were amazing and hit the spot. For our mains we went for the same as before ..if it's not broke don't fix it! ...Mrs chose butter chicken and I opted for steak pie. Yet again this wee place delivers and chef Alvin is bang on the money with his dishes.",
    rating: 5
  },
  {
    title: "Superb as always",
    content: "Great food, great beer, well looked after pool and snooker tables. Staff always pleasant and helpful. Good selection of draughty beers. The Creamery is the best place in Falkirk and Forth Valley if you like pool and snooker. Besides well looked after tables and equipment, the owners are knowledgeable and enthusiastic about their trade.",
    rating: 5
  },
  {
    title: "Falkirk's best secret",
    content: "This place is Falkirk's special secret so don't tell too many people. The food is fab, the staff are on point and the bar is great for a quiet drink where you can watch most sports. This place should be buzzing every night. New car park also and it's as honest a place as they come. This is far more than Pool or Snooker, it's about what you want it to be.",
    rating: 5
  },
  {
    title: "Lovely feel to this homely, friendly place",
    content: "I come here often with family and with friends. The food is great and the staff are so friendly. It feels like a real homely place. I can definitely recommend it. See you next week for Christmas girlie get together..... so looking forward to it.",
    rating: 5
  },
  {
    title: "The best food by far",
    content: "The service was second to none.. the food was amazing .. great portion size the restaurant was very clean as were the toilets..actually our family and friends have been coming almost every week since September.. absolutely 💯 the best",
    rating: 5
  },
  {
    title: "Delicious food at great prices",
    content: "I have visited The Creamery a few times and have never been disappointed. The restaurant is a hidden gem just off the main street in Bainsford. It is beautifully decorated with modern vibe. The menu offers a great range to choose from. However, when the food arrives, you are absolutely blown away but the generous portions and delicious food!",
    rating: 5
  },
  {
    title: "Family favourite",
    content: "We started coming here in 2001 and can honestly say we have never once had a bad meal or bad experience. I couldn't say that about anywhere else. The Cajun chicken has been ordered hundreds of times and is still a firm family favourite.",
    rating: 5
  },
  {
    title: "Best.steak.pie.ever",
    content: "Great honest pub grub. Our family are regular visitors because the meals are always tasty, the staff are really friendly and always welcoming. The steak pie is definitely the best in Falkirk. Tasty cocktails too. Their Sport bar area is dog friendly, the restaurant on the other side is quieter where you can relax and have a lovely meal.",
    rating: 5
  },
  {
    title: "Outstanding",
    content: "Outstanding food, service and staff. We try to visit twice a month. Absolutely love this place. Service is second to none and portions are of a generous size.",
    rating: 5
  },
  {
    title: "Fantastic dinner and night out",
    content: "Table of 8 for dinner then stayed for quiz night. Great atmosphere, staff were lovely and meal was amazing- three course for a brilliant price. Hunters Chicken was beautiful, portions were huge. Would definitely recommend.",
    rating: 5
  },
  {
    title: "Always a lovely meal",
    author: "Lorraine Thomson",
    content: "Always a lovely meal here, food is piping hot and very well presented. Staff are always cheerful and make you feel very welcome.",
    rating: 5
  },
  {
    title: "Good value for money",
    author: "Elaine Thomson",
    content: "Good value for money and very tasty food. Friendly and polite staff, catered all our needs. Would recommend highly",
    rating: 5
  },
  {
    title: "Fantastic food",
    author: "Catherine Kay",
    content: "Fantastic food. Generous portion sizes. Very good value for money. We go regularly. Kids meals are also good value. Highly recommend",
    rating: 5
  },
  {
    title: "Hidden gem",
    author: "Karen Jack",
    content: "Just started visiting creamery recently, and we were not disappointed for this small restaurant is a hidden gem. Had breakfast lunch and dinner in here and couldn't fault it.",
    rating: 5
  }
];

const snookerReviews: Review[] = [
  {
    title: "Good place for a game",
    author: "Mr Ava",
    content: "Good place for a game of pool or snooker, in the area. American pool table cloths are in good nick compared to other halls elsewhere.",
    rating: 5
  },
  {
    title: "Pool tables are great",
    author: "Peter Elliot",
    content: "Pool tables are great and bar is well stocked. Nice decor and atmosphere",
    rating: 5
  },
  {
    title: "Excellent tables",
    author: "James Muir",
    content: "Been come here for over a year with my oldest son, friendly staff, American pool tables are excellent, well maintained, clean and tidy, food and drink also excellent",
    rating: 5
  },
  {
    title: "Nice atmosphere",
    author: "James Walker",
    content: "Went for some pool. Nice place with a nice atmosphere. Reasonably priced as well.",
    rating: 5
  },
  {
    title: "Great atmosphere in the pool Hall",
    author: "Douglas J Grieve",
    content: "Great atmosphere in the pool Hall. Decent beer and a good jukebox. Nice and quiet in the snooker side. Exactly what you want. Great tables.",
    rating: 4
  },
  {
    title: "American pool tables are brill",
    author: "Mrs F",
    content: "The American pool tables are brill and not very expensive to use. The jukebox and sound is fab. Great bar.",
    rating: 5
  },
  {
    title: "Great place to go for a game",
    author: "Colin Spiers",
    content: "Great food. Staff are fantastic and pool/snooker tables are well looked after. Great place to go for a game.",
    rating: 5
  }
];

const ReviewCarousel: React.FC<ReviewCarouselProps> = ({ type }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const reviews = type === 'restaurant' ? restaurantReviews : snookerReviews;

  const nextReview = () => {
    setCurrentIndex((prev) => (prev + 1) % reviews.length);
  };

  const prevReview = () => {
    setCurrentIndex((prev) => (prev - 1 + reviews.length) % reviews.length);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % reviews.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [reviews.length]);

  const currentReview = reviews[currentIndex];

  return (
    <div className="w-full max-w-6xl mx-auto px-4 py-8 md:py-16">
      <div className="flex items-center gap-4 md:gap-8">
        {/* Desktop side buttons - hidden on mobile */}
        <button
          onClick={prevReview}
          className="hidden md:flex p-3 rounded-full bg-primary-gold/10 hover:bg-primary-gold/20 transition-colors flex-shrink-0"
          aria-label="Previous review"
        >
          <ChevronLeft className="w-6 h-6 text-primary-gold" />
        </button>

        <div className="bg-primary-black rounded-lg shadow-2xl p-6 md:p-12 flex-1">
          <div className="flex items-center justify-center mb-4 md:mb-6">
            {[...Array(5)].map((_, i) => (
              <Star
                key={i}
                className={`w-5 h-5 md:w-6 md:h-6 ${
                  i < currentReview.rating
                    ? 'fill-primary-gold text-primary-gold'
                    : 'text-gray-600'
                }`}
              />
            ))}
          </div>

          <h3 className="text-xl md:text-3xl font-bold text-primary-gold mb-4 md:mb-6 text-center font-display">
            {currentReview.title}
          </h3>

          <p className="text-gray-300 text-base md:text-lg leading-relaxed mb-6 md:mb-8 text-center max-w-3xl mx-auto">
            {currentReview.content}
          </p>

          <div className="text-center text-gray-400 mb-4 md:mb-0">
            {currentReview.author && (
              <p className="font-semibold text-primary-gold">{currentReview.author}</p>
            )}
            {currentReview.date && (
              <p className="text-sm mt-1">{currentReview.date}</p>
            )}
          </div>

          {/* Mobile navigation buttons */}
          <div className="flex md:hidden items-center justify-center gap-4 mt-6 mb-4">
            <button
              onClick={prevReview}
              className="p-2 rounded-full bg-primary-gold/10 hover:bg-primary-gold/20 transition-colors"
              aria-label="Previous review"
            >
              <ChevronLeft className="w-5 h-5 text-primary-gold" />
            </button>
            <div className="text-center text-sm text-gray-500">
              {currentIndex + 1} / {reviews.length}
            </div>
            <button
              onClick={nextReview}
              className="p-2 rounded-full bg-primary-gold/10 hover:bg-primary-gold/20 transition-colors"
              aria-label="Next review"
            >
              <ChevronRight className="w-5 h-5 text-primary-gold" />
            </button>
          </div>

          {/* Desktop counter */}
          <div className="hidden md:block text-center mt-6 text-sm text-gray-500">
            {currentIndex + 1} / {reviews.length}
          </div>

          {/* Social links - responsive layout */}
          <div className="flex flex-col md:flex-row items-center justify-center gap-3 md:gap-4 mt-6 md:mt-8 pt-6 border-t border-gray-800">
            <p className="text-gray-400 text-sm md:mr-2">Leave us a review:</p>
            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full sm:w-auto">
              <a
                href="https://share.google/wbD1mJk0FB1ZsfsDg"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-2 px-4 py-2 bg-primary-gold/10 hover:bg-primary-gold/20 rounded-lg transition-colors border border-primary-gold/30"
                aria-label="Google Reviews"
              >
                <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
                  <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
                  <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
                  <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
                </svg>
                <span className="text-primary-gold text-sm font-medium">Google</span>
              </a>
              <a
                href="https://www.tripadvisor.com/Restaurant_Review-g186527-d6528165-Reviews-The_Creamery_Sports_Bar-Falkirk_Falkirk_District_Scotland.html"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-2 px-4 py-2 bg-primary-gold/10 hover:bg-primary-gold/20 rounded-lg transition-colors border border-primary-gold/30"
                aria-label="TripAdvisor"
              >
                <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12.006 4.295c-2.67 0-5.338.784-7.645 2.353H0l1.963 2.135a5.997 5.997 0 0 0 4.04 10.43 5.976 5.976 0 0 0 4.075-1.6L12 19.705l1.922-2.09a5.972 5.972 0 0 0 4.072 1.598 6 6 0 0 0 4.039-10.429L24 6.648h-4.361c-2.307-1.569-4.974-2.353-7.633-2.353zm-6 7.354a3.976 3.976 0 0 1-2.309 3.622 3.976 3.976 0 0 1-4.336-.925 3.976 3.976 0 0 1-.925-4.336 3.976 3.976 0 0 1 3.622-2.309 3.976 3.976 0 0 1 3.622 2.309 3.976 3.976 0 0 1-.674 4.639zm.591-2.002a1.99 1.99 0 1 0-3.98 0 1.99 1.99 0 0 0 3.98 0zm11.805 5.625a3.976 3.976 0 0 1-4.336.925 3.976 3.976 0 0 1-2.309-3.622 3.976 3.976 0 0 1 2.309-3.622 3.976 3.976 0 0 1 4.336.925 3.976 3.976 0 0 1 .925 4.336 3.976 3.976 0 0 1-.925 1.058zm-.592-4.625a1.99 1.99 0 1 0 0 3.98 1.99 1.99 0 0 0 0-3.98z" fill="#00AF87"/>
                </svg>
                <span className="text-primary-gold text-sm font-medium">TripAdvisor</span>
              </a>
              <a
                href="https://www.facebook.com/thecreameryfalkirk/?locale=en_GB"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-2 px-4 py-2 bg-primary-gold/10 hover:bg-primary-gold/20 rounded-lg transition-colors border border-primary-gold/30"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5 text-[#1877F2]" />
                <span className="text-primary-gold text-sm font-medium">Facebook</span>
              </a>
            </div>
          </div>
        </div>

        {/* Desktop side buttons - hidden on mobile */}
        <button
          onClick={nextReview}
          className="hidden md:flex p-3 rounded-full bg-primary-gold/10 hover:bg-primary-gold/20 transition-colors flex-shrink-0"
          aria-label="Next review"
        >
          <ChevronRight className="w-6 h-6 text-primary-gold" />
        </button>
      </div>
    </div>
  );
};

export default ReviewCarousel;
